export default {
    namespaced: true,
    state: {
        level: 0,
        date: 'today',
        department: 0,
        departments: ['tryg', 'alka'],
        settings: null
    },
    getters: {
        department (state) {
            return state.departments[state.department]
        },
        settings (state, getters, rootState) {
            return state.settings[rootState.main.department] || state.settings[getters.department]
        }
    }
}